export default __webpack_public_path__ + "static/media/Betty_LaMarr_AHV_In_Moms_We_Trust.72104311.jpg";